import "../App.css";
import Iframes from "./Iframes";
function Home() {
  return (
    <div className="App">
      <h3 className="App-header">
        <div>NBA API Home </div>
        <Iframes />
      </h3>
    </div>
  );
}

export default Home;
